<template lang="pug">
.m-card-body.collapse.show(:id="'league-' + source.id" :aria-labelledby="source.id")
  .m-card-item.outright
    .m-card-wrap
      .m-card-odds
        swiper.odds-swiper(ref="sw" :options="swiperOptions" @slideChange="handleSlideChange")
          template(v-for="(a,b) in Math.ceil(source.matchList.length/itemPerRows)")
            swiper-slide(:class="(source.marketId == 3) ? 'live' : ''")
              .odds-group
                .row(v-for="option in source.matchList.slice(b*itemPerRows, (b+1)*itemPerRows)")
                  template(v-if="option.details.orz")
                    OddsItem(:odds="option.details.orz[0]" idx=5 :typ="oddsType" dataType="4" mode="orz" count=0 :label="option.matchBody[5]" :details="option.details.orz")
          .swiper-pagination(slot="pagination")
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem
  },
  mixins: [mixinHDPOUOdds],
  data() {
    return {
      activeIndex: 0,
      itemPerRows: 3,
      swiperOptions: {
        slidesPerView: 2,
        spaceBetween: 5,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        // breakpoints: {
        //   768: {
        //     slidesPerView: 2,
        //     spaceBetween: 10, 
        //   }
        // } 
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.sw ? this.$refs.sw.$swiper : 0;
    }
  },
  mounted() {
    this.activeIndex = this.swiper.activeIndex;
  },
  methods: {
    handleSlideChange() {
      this.activeIndex = this.swiper.activeIndex;
    }
  }
};
</script>
